import CardOne from "./components/images/Card1.jpg";
import CardTwo from "./components/images/Card2.jpg";
import CardThree from "./components/images/Card3.jpg";
export const mycarddata = [
  {
    id: 3,
    Img: CardTwo,

    title: "Jaytechent Basic Plan",
    description:
      "This Plan is freemium plan that you can use for small business",
  },
  {
    Img: CardOne,
    id: 2,

    title: "Jaytechent Premier Plan",
    description:
      "This Plan is freemium plan that you can use for small business",
  },
  {
    id: 1,
    Img: CardThree,

    title: "Jaytechent Premium Plan",
    description:
      "This Plan is freemium plan that you can use for small business",
  },
];
